import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LiferayService } from '../../../services/liferay/liferay.service';
import { Subject, takeUntil } from 'rxjs';
import { IWebContant } from '../../../services/liferay/liferay.interface';

@Component({
  selector: 'app-liferay-content',
  templateUrl: './liferay-content.component.html',
  styleUrl: './liferay-content.component.scss'
})
export class LiferayContentComponent implements OnInit, OnDestroy {
  @Input() contentType: string = 'html';
  @Input() contentId: string = '';

  webContent!: IWebContant<string>;
  cleaner$ = new Subject<void>();
  loading:boolean=false;

  constructor(
    private liferayContentService: LiferayService
  ) { }

  ngOnInit() {
    this.loading=true;

    if (this.contentId) {
      this.liferayContentService.getWebContent<string>(this.contentType, this.contentId).pipe(takeUntil(this.cleaner$)).subscribe({
        next: (results: IWebContant<string>) => {
          this.webContent = results;
          this.loading = false;
        }
      });
    }
  }


  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }
}
